import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";
import { PolicySequencesTab } from "../../../../../emailSequences/components/PolicySequencesTab";

export const BusinessSequencesRoutes = [
  {
    path: "/business-policy/:customerId/sequences/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <PolicySequencesTab />
      </AuthorizedRoute>
    ),
  },
];
